
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/casos/brinks",
      function () {
        return require("private-next-pages/[locale]/casos/brinks.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/casos/brinks"])
      });
    }
  